import { D as DictionarySorter } from './dictionarySorter-1f1c5424.js';
import { D as DictionaryFilter } from './dictionaryFilter-769f7408.js';

var DictionarySelectKeys;
(function (DictionarySelectKeys) {
    DictionarySelectKeys["Code"] = "code";
    DictionarySelectKeys["Display"] = "display";
})(DictionarySelectKeys || (DictionarySelectKeys = {}));
class DictionarySerializer {
    static getCodeDescriptionDisplay(dto) {
        var _a;
        return !!(dto === null || dto === void 0 ? void 0 : dto.description) && !!(dto === null || dto === void 0 ? void 0 : dto.code)
            ? `${dto.code} - ${dto.description}`
            : (_a = dto.code) !== null && _a !== void 0 ? _a : '';
    }
    static getCodeNameDisplay(dto) {
        var _a;
        return !!(dto === null || dto === void 0 ? void 0 : dto.name) && !!(dto === null || dto === void 0 ? void 0 : dto.code)
            ? `${dto.code} - ${dto.name}`
            : (_a = dto.code) !== null && _a !== void 0 ? _a : '';
    }
    static mapToSelectDisplay(items, options) {
        var _a, _b, _c;
        const sorter = (_a = options.sorter) !== null && _a !== void 0 ? _a : DictionarySorter.displaySequenceAndCode.ascending;
        const serializer = (_b = options.serializer) !== null && _b !== void 0 ? _b : DictionarySerializer.getCodeDescriptionDisplay;
        const filter = (_c = options.filter) !== null && _c !== void 0 ? _c : DictionaryFilter.byActiveItem;
        return items
            .filter(filter)
            .sort(sorter)
            .map((item) => {
            var _a;
            return ({
                [DictionarySelectKeys.Code]: (_a = item.code) !== null && _a !== void 0 ? _a : '',
                [DictionarySelectKeys.Display]: serializer(item),
            });
        });
    }
}

export { DictionarySerializer as D, DictionarySelectKeys as a };
//# sourceMappingURL=dictionarySerializer-969da3d0.js.map
